import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const Layout: React.FC = () => {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#ffffff', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      <Header />
      <main style={{ margin: '0 auto', padding: '2rem' }}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;